import { validateUser } from '$lib/stores/user/action';
import { user } from '$lib/stores/user/store';
import { get } from 'svelte/store';

// TODO: type of all these and other page based policies

export const ALLOW_ALL_NO_VALIDATE = async () => {
	return true;
};

export const ACTIVE_USERS_ONLY = async () => {
	try {
		await validateUser();
		const currentUser = get(user);
		return Boolean(currentUser.isActive);
	} catch (error) {
		return false;
	}
};

export const ALLOW_ALL = async () => {
	try {
		await validateUser();
		return true;
	} catch (error) {
		return false;
	}
};

export const INACTIVE_USERS_ONLY = async () => {
	try {
		await validateUser();
		const { isActive, tokenValid } = get(user);
		return tokenValid && !isActive;
	} catch (error) {
		return false;
	}
};

export const LOGGED_OUT_USERS_ONLY = async () => {
	try {
		await validateUser();
		const currentUser = get(user);
		return !currentUser.tokenValid;
	} catch (error) {
		return false;
	}
};

export const LOGGED_IN_USERS_ONLY = async () => {
	try {
		await validateUser();
		const currentUser = get(user);
		return currentUser.tokenValid;
	} catch (error) {
		return false;
	}
};
